import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import resources from "./i18n/translation.json"

// const pathLang = window.location.pathname.slice(1, 3)
const params = new URLSearchParams(window.location.search)
const pathLang = params.get("lang")
const DEFAULT_LANG = pathLang === "tc" ? "tc" : pathLang === "sc" ? "sc" : "en"

i18n.use(initReactI18next).init({
  resources,
  supportedLngs: ["tc", "sc", "en"],
  lowerCaseLng: true,
  lng: DEFAULT_LANG,
  nsSeparator: false,
  keySeparator: false,
  debug: false,
  interpolation: { escapeValue: false },
})

export default i18n
